(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("rxjs/operators"), require("@angular/forms"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "rxjs/operators", "@angular/forms"], factory);
	else if(typeof exports === 'object')
		exports["ngx-bootstrap-emma.umd.min"] = factory(require("@angular/core"), require("@angular/common"), require("rxjs/operators"), require("@angular/forms"));
	else
		root["ngx-bootstrap-emma.umd.min"] = factory(root["@angular/core"], root["@angular/common"], root["rxjs/operators"], root["@angular/forms"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 